import { PostFunction } from "src/utils/axios_connection";
import UrlApi from "src/utils/Url";

// The calls behind the website content pages. Same routes and payloads the
// old tables sent. PostFunction shows the server's message on failure and
// throws; the pages keep what is on screen and say what to do next.
// A list that fails says so on the page (ResourceList), so it doesn't toast too.
const call = (route, data, dispatch, isMultipart = false, showerror = true) =>
  PostFunction({ Route: route, data, isMultipart, showalert: false, showerror, dispatch });

// A FormData from an object; File values are sent as files, empty values are
// left out unless `keepEmpty` names them.
export function formData(values, keepEmpty = []) {
  const body = new FormData();
  Object.entries(values).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    if (value === "" && !keepEmpty.includes(key)) return;
    body.append(key, value);
  });
  return body;
}

export const rows = (response) => (Array.isArray(response?.data) ? response.data : []);

export const contentApi = {
  services: {
    list: (dispatch) => call(UrlApi.services.get, {}, dispatch, false, false).then(rows),
    add: (values, dispatch) => call(UrlApi.services.add, formData(values), dispatch, true),
    edit: (values, dispatch) => call(UrlApi.services.edit, formData(values), dispatch, true),
    set: (id, field, value, dispatch) => call(UrlApi.services.edit, { id, [field]: value }, dispatch),
    remove: (id, dispatch) => call(UrlApi.services.delete, { idsservices: [id] }, dispatch),
  },
  workingProcess: {
    list: (dispatch) => call(UrlApi.working_process.get, { is_active: null }, dispatch, false, false).then(rows),
    add: (values, dispatch) => call(UrlApi.working_process.add, formData(values), dispatch, true),
    edit: (values, dispatch) => call(UrlApi.working_process.edit, formData(values, ["image"]), dispatch, true),
    set: (id, field, value, dispatch) => call(UrlApi.working_process.edit, formData({ id, [field]: value }), dispatch, true),
    remove: (id, dispatch) => call(UrlApi.working_process.delete, { idscountryprocesstype: [id] }, dispatch),
  },
  faq: {
    list: (dispatch) => call(UrlApi.faq.get, { is_active: null }, dispatch, false, false).then(rows),
    add: (values, dispatch) => call(UrlApi.faq.add, values, dispatch),
    // showerror false: the page says what failed in its own words.
    edit: (values, dispatch, showerror = true) => call(UrlApi.faq.edit, values, dispatch, false, showerror),
    set: (id, field, value, dispatch) => call(UrlApi.faq.edit, { id, [field]: value }, dispatch),
    remove: (id, dispatch) => call(UrlApi.faq.delete, { idsfaqs: [id] }, dispatch),
  },
  testimonials: {
    list: (dispatch) => call(UrlApi.testimonials.get, {}, dispatch, false, false).then(rows),
    clients: (dispatch) => call(UrlApi.clients.get, { rowsPerPage: 5000, page: 0 }, dispatch).then(rows),
    add: (values, dispatch) => call(UrlApi.testimonials.add, values, dispatch),
    edit: (values, dispatch) => call(UrlApi.testimonials.edit, values, dispatch),
    set: (id, field, value, dispatch) => call(UrlApi.testimonials.edit, { id, [field]: value }, dispatch),
    remove: (id, dispatch) => call(UrlApi.testimonials.delete, { idstestimonials: [id] }, dispatch),
  },
  trustedBy: {
    list: (dispatch) => call(UrlApi.trusted_by.get, {}, dispatch, false, false).then(rows),
    add: (image, dispatch) => call(UrlApi.trusted_by.add, formData({ image }), dispatch, true),
    edit: (id, image, dispatch) => call(UrlApi.trusted_by.edit, formData({ trusted_by_id: id, image }), dispatch, true),
    remove: (id, dispatch) => call(UrlApi.trusted_by.delete, { idstrustedby: [id] }, dispatch),
  },
  stats: {
    list: (dispatch) => call(UrlApi.stats.get_table, {}, dispatch, false, false).then(rows),
    add: (values, dispatch) => call(UrlApi.stats.add, values, dispatch),
    edit: (values, dispatch) => call(UrlApi.stats.edit, values, dispatch),
    set: (id, field, value, dispatch) => call(UrlApi.stats.edit, { id, [field]: value }, dispatch),
    remove: (id, dispatch) => call(UrlApi.stats.delete, { idsstats: [id] }, dispatch),
  },
  contact: {
    list: (dispatch) => call(UrlApi.contact_us.get, {}, dispatch, false, false).then(rows),
    add: (values, dispatch) => call(UrlApi.contact_us.add, values, dispatch),
    edit: (values, dispatch) => call(UrlApi.contact_us.edit, values, dispatch),
    set: (id, field, value, dispatch) => call(UrlApi.contact_us.edit, { id, [field]: value }, dispatch),
    remove: (id, dispatch) => call(UrlApi.contact_us.delete, { idscontactus: [id] }, dispatch),
  },
};
